module.exports = __webpack_public_path__ + "static/img/PS.b1a9f476.png";